var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-calendar',_vm._b({attrs:{"hide-header":true,"locale":_vm.locale,"width":"280px"}},'b-calendar',_vm.labels || {},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }